const translations = {
  "en": {
    "Related accounts": "Related accounts"
  },
  "zh-tw": {
    "Related accounts": "相關帳號"
  }
};

export default translations;
